"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERLAY_DELETE = void 0;
var OVERLAY_DELETE = exports.OVERLAY_DELETE = 'overlayDelete';